import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AC9017C0-F5E5-4AD8-819F-5B540AC12FED
 * name gate-buffer
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-buffer.svg
 * tags
 */
export const GateBufferIcon = createSvgIcon(<><path d="M6 7.24L15.53 12L6 16.76V7.24M4 4V20L20 12L4 4Z" /></>, 'GateBufferIcon');
export default GateBufferIcon